





































import { Vue, Component } from "@/shared/vuepack";
import { GChart } from "vue-google-charts";
import moment from "moment";
import { formatCurrency } from "@/shared/currency.js";
import { usePayrollDashboardStore } from "@/employer/store/payrollDashboard";

@Component({
  components: { GChart }
})
export default class EmployeeContributionChart extends Vue {

  payrollDashboardStore = usePayrollDashboardStore();

  formatCurrency = formatCurrency;

  chartOptions = {
    colors: ["#00af89", "#00af89"],
    legend: {position: "none"},
    width: "100%",
    height: "100%",
    hAxis: {
      gridlines: {
        color: "transparent"
      },
      baselineColor: "black"
    },
    vAxis: {
      format: "currency",
      gridlines: {
        color: "transparent"
      },
      baselineColor: "black",
      minValue: 0,
      maxValue: 1,
      viewWindowMode: "pretty"
    },
    tooltip: {
      isHtml: true,
      trigger: "none"
    }
  };

  mounted () {
    this.getChartData(moment().year());
  }

  getChartData (year: number) {
    this.payrollDashboardStore.initEmployeeContributionsGraph(year);
  }

  get showYearSelector () {
    return this.payrollDashboardStore.employeeContributionsYears &&
        this.payrollDashboardStore.employeeContributionsYears.length > 1;
  }
}
